import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/LeasedEquipmentConfiguration";

export const getLeasedEquipmentModelList = async () => {
  return axios.get(`${api_base_url}/GetModel`).then((res) => {
    return res;
  });
};

export const addLeasedEquipmentModel = async (newModel) => {
  const { data } = await axios.post(`${api_base_url}/AddModel`, {
    ...newModel,
  });
  return data;
};

export const deleteLeasedEquipmentModel = async (ids) => {
  const { data } = await axios.delete(`${api_base_url}/DeactivateModel`, {
    data: ids,
  });
  return data;
};

export const updateLeasedEquipmentModel = async (editLeasedEquipmentModel) => {
  const { data } = await axios.put(
    `${api_base_url}/EditModel`,
    editLeasedEquipmentModel
  );
  return data;
};
